import { render, staticRenderFns } from "./WarehouseConfigDetailRevenueTable.vue?vue&type=template&id=42e0d94f&scoped=true&"
import script from "./WarehouseConfigDetailRevenueTable.vue?vue&type=script&lang=js&"
export * from "./WarehouseConfigDetailRevenueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e0d94f",
  null
  
)

export default component.exports